import React, { useEffect, useState } from "react";
import BookingModal from "./BookingModal";
const BookingSummaryComponent = (props) => {
  const [amount, setamount] = useState(0)
  const [showBookingModal, setshowBookingModal] = useState(false);
  useEffect(() => {
    setamount(props.newBooking.seats.reduce((a, c) => a + c.seatPrice, 0));

  }, [props.newBooking.seats])

  return (
    <div className="lg:w-[40%]">
      <div className="bg-[#f5f5f5] mt-4 mb-2 px-5 py-3">
        <div className="flex items-center justify-between mb-2">
          <p className="text-lg font-bold ">Boarding & Dropping Points</p>
          <p className="text-blue-500 cursor-pointer  font-bold" onClick={() => props.onClick(false)}>CHANGE</p>
        </div>

        <div className="flex gap-5">
          <p className="w-[60%]">{props.newBooking.boardingPoint.pointname}</p>
          <p>{props.newBooking.boardingPoint.time}</p>
        </div>
        <div className="flex gap-5 mb-3">
          <p className="w-[60%]">{props.newBooking.droppingPoint.pointname}</p>
          <p>{props.newBooking.droppingPoint.time}</p>
        </div>
        <hr />
        <div className="flex justify-between mb-3 items-center mt-2 ">
          <p className="text-lg font-bold">Seat No.</p>
          <p className="flex text-lg font-bold items-center gap-2">
            {props.newBooking.seats.map((x) => (
              <span>{x.seatNumber},</span>
            ))}
          </p>
        </div>
        <hr />
        <div>
          <p className="text-lg font-bold mb-2 mt-2">Fare Details</p>
          <div className="flex justify-between mb-3 items-center mt-2 ">
            <p className="">Amount</p>
            <p className="font-bold">INR {amount}</p>
          </div>
        </div>
        <button
          onClick={() => setshowBookingModal(true)}
          className="bg-blue-500 text-white p-auto w-[100%] mb-4 py-2 text-lg"
        >
          Proceed To Book
        </button>
      </div>
      {showBookingModal ? <BookingModal updateSeatWithPerson={props.updateSeatWithPerson} addContactDetails={props.addContactDetails} userid={props.userid} journeyDetails={props.journeyDetails} newBooking={props.newBooking} on={(value) => setshowBookingModal(value)} /> : <></>}
    </div>

  );
};

export default BookingSummaryComponent;
